module.exports = __webpack_public_path__ + "static/wellovci-na-terasi-well-offica-u-scc-sarajevo-c1ff1d547fa031178c687dc539118f47.jpg";